import { ReactNode } from 'react';

import { PortalCompanyAdminSettings } from '@willow/graphql-iso/src/portal';
import { AppContext as AppContextEnv } from '@willow/shared-iso';
import { NamedMemo, useSentryContext } from '@willow/shared-web';

import { PortalSelectedLoan } from '../../App';
import { FeatureFlagContextProvider } from '../../contexts/FeatureFlagContextProvider';
import { EnvironmentContext } from './EnvironmentContext';
import { EmptyPortalUser, PortalUser, UserContext } from './UserContext';

export const AppContext = NamedMemo<{
  user: PortalUser | EmptyPortalUser;
  selectedLoan: PortalSelectedLoan | undefined;
  allCompanySettings: PortalCompanyAdminSettings[] | undefined;
  environment: AppContextEnv;
  children: ReactNode;
}>('AppContext', ({ children, allCompanySettings, selectedLoan, user, environment }) => {
  useSentryContext(user);
  return (
    <EnvironmentContext.Provider value={environment}>
      <UserContext.Provider value={user}>
        <FeatureFlagContextProvider allCompanySettings={allCompanySettings} selectedLoan={selectedLoan}>
          {children}
        </FeatureFlagContextProvider>
      </UserContext.Provider>
    </EnvironmentContext.Provider>
  );
});
